import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { createPlaywrightCSharpSpecflow } from "../../../../../../../../../../../store/slices/test-automation/web/flow-stages/playwrightCSharpSpecflowSlices";
import { createStepNavigationHandler, getCurrentStepFromRoute, getStepperSteps } from "../../../../../../../../../../../utils/stepperConfig";
import { Box } from "@mui/material";
import CustomStepper from "../../../../../../../../../../custom-components/CustomStepper";
import { useNavigateWithSameKey } from "../../../../../../../../../../../custom-hooks/navigateWithKey";
// import { setAutomationPath, setAutomationType, setEnvironment, setPreferences, setTestCases } from "../../../../../../../../../../../store/slices/test-automation/web/flow-stages/playwrightCSharpSpecflowSlices";

const PlaywrightCSharpSpecflowNTNP = () => {
  const location = useLocation();
  const navigate = useNavigateWithSameKey();
  const dispatch = useDispatch();

  const locationKey = location.state?.locationKey;

  const webAutomationData = useSelector(
    (state) =>
      state["testAutomation"][locationKey]["webAutomation"] || {}
  );
  
  const preferences = webAutomationData["automationPreferences"];
  const playwrightCSharpSpecflow = webAutomationData["playwrightCSharpSpecflow"];

  useEffect(() => {
    if (!locationKey) {
      navigate("/landingpage");
      return;
    }

    if (!playwrightCSharpSpecflow) {
      dispatch(createPlaywrightCSharpSpecflow(locationKey));
    }
  }, [locationKey, playwrightCSharpSpecflow]);

  const { steps, activeStep, stepNavigationHandler } = useMemo(() => {
    // Get preferences for step generation (with fallbacks for ReqNRoll C#)
    const stepPreferences = {
      automationTool: preferences.automationTool || "playwright",
      framework: preferences.framework || "specflow", // ReqNRoll framework
      programmingLanguage: preferences.programmingLanguage || "csharp",
      ...preferences,
    };

    // Get dynamic steps based on preferences
    const dynamicSteps = getStepperSteps(stepPreferences);

    // Get current step index using centralized route mapping
    const currentStepIndex = getCurrentStepFromRoute(
      location.pathname,
      stepPreferences
    );

    // Create navigation handler for step clicks
    // Extract base path (everything except the last segment)
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const basePath = "/" + pathSegments.slice(0, -1).join("/");
    const navigationHandler = createStepNavigationHandler(
      navigate,
      basePath,
      stepPreferences
    );

    return {
      steps: dynamicSteps,
      activeStep: currentStepIndex,
      stepNavigationHandler: navigationHandler,
    };
  }, [location.pathname, preferences, navigate]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CustomStepper
        steps={steps}
        activeStep={activeStep}
        maxWidth="100%"
        containerWidth="100%"
        activeColor="#1976d2"
        completedColor="#40a9ff"
        pendingColor="#d1d1d1"
        showNextStep={true}
        showStepCount={true}
        title="Now"
        inProgressText="(In Progress)"
        completedText="(Completed)"
        nextText="Next"
        completedNextText="Completed"
        stepText="Step"
        // Click Navigation Props
        onStepClick={stepNavigationHandler}
        allowClickNavigation={true}
        clickableSteps="completedAndNext" // Allow clicking on completed steps and next step
      />
      <Outlet />
    </Box>
  );
};

export default PlaywrightCSharpSpecflowNTNP;
